import styled, { css } from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import ActionCard from '../ActionCard'
import BlockTitle from '../BlockTitle'

export const Container = styled.section`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(56)};
  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(144)};
  }
`
export const _BlockTitle = styled(BlockTitle)`
  width: 100%;
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
  @media ${mq(sizes.desktop)} {
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
`

export const Grid = styled.ul`
  list-style: none;
  gap: ${pxToRem(16)};
  width: 100%;
  margin-inline: auto;
  & li {
    display: flex;
  }
  display: flex;
  flex-flow: column;
  max-width: calc(100% - ${pxToRem(16)} * 2);
  @media ${mq(sizes.tablet)} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
  @media ${mq(sizes.big)} {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    max-width: calc(100% - ${pxToRem(32)} * 2);
    & li:nth-child(1) {
      grid-column-start: 2;
    }
    & li:nth-child(2) {
      grid-column-start: 3;
    }
    & li:nth-child(3) {
      grid-column-start: 1;
    }
    & li:nth-child(4) {
      grid-column-start: 3;
    }
    & li:nth-child(5) {
      grid-column-start: 1;
    }
    & li:nth-child(6) {
      grid-column-start: 2;
    }
  }
`

export const _ActionCard = styled(ActionCard)<{ $ratio?: number }>`
  flex: 1;
  width: 100%;
  & img {
    height: 100%;
    object-fit: cover;
  }
  aspect-ratio: 7 / 8;
  @media ${mq(sizes.tablet)} {
    aspect-ratio: 9 / 8;
  }
  /* ${({ $ratio }) =>
    $ratio &&
    css`
      aspect-ratio: ${$ratio};
    `}; */
`
